import { TFunction } from "i18next";
import { FirstLetterUpperCase } from "../helpers/helpersSearchs";

export const statusLicensesOptions = (t: TFunction<"global", undefined>) => [
  {
    value: "unassigned",
    label: t("licenses.unassigned"),
    description: "",
    id: "unassigned",
  },
  {
    value: "runningLow",
    label: t("licenses.lowOrEmpty"),
    description: "",
    id: "runningLow",
  },
  {
    value: "expiringSoon",
    label: t("licenses.expSoon"),
    description: "",
    id: "expiringSoon",
  },
  {
    value: "expired",
    label: FirstLetterUpperCase(t("licenses.expired")),
    description: "",
    id: "expired",
  },
];
